







import {Component, Prop, Vue} from "vue-property-decorator";
import {AxiosError, AxiosResponse} from "axios";
import {mapGetters} from "vuex";

@Component({
    computed: {...mapGetters(["user"])},
    components: {},
})
export default class FollowBtn extends Vue {
    @Prop() member!: any;
    user!: any;


    async  mounted(){
        await this.$store.dispatch("loginState")
    }

    follow() {
        this.$api.follow(this.member.id)
            .then((res: AxiosResponse) => {
                this.$emit('reFetch')
            })
            .catch((err: AxiosError) => {

            })

    }

    unfollow() {
        this.$api.unfollow(this.member.id)
            .then((res: AxiosResponse) => {
                this.$emit('reFetch')
            })
            .catch((err: AxiosError) => {

            })

    }

    myChannel(channel_id: string) {
        this.$router.push(`/${this.$i18n.locale}/channel/${channel_id}/timeline`)

    }

}
